import { render, staticRenderFns } from "./AppsDrawer.vue?vue&type=template&id=241dcf60&"
import script from "./AppsDrawer.vue?vue&type=script&lang=js&"
export * from "./AppsDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports